import * as React from "react";
import Loader from 'rsuite/lib/Loader';

export interface LazyLoadingAnimationProps {
    style?: React.CSSProperties;
}

export var LazyLoadingAnimation = (props: LazyLoadingAnimationProps) => (
    <div style={{
        borderRadius: 15, position: "absolute", overflow: "hidden",
        ...props.style
    }}>
        <Loader center backdrop inverse speed='slow' size='md' />
    </div>
);

export var LazyLoadingAnimationOld = (props: LazyLoadingAnimationProps) => (
    <div style={{ color: "rgb(19, 68, 89)", ...props.style }}>
        <div style={{ padding: '8px 0', margin: 10 }} className="loader">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading...</h3>
    </div>
);